<template>
  <div class="ban">
    <div class="demo-input-suffix">
      <el-input
        placeholder="SKU/Product Name"
        v-model="Queryproductval"
        @blur="Queryproduct"
        class="input"
        suffix-icon="el-icon-search"
      ></el-input>
      <span class="Synchronize">
        <el-badge :value="storage" style>
          <router-link to="/storage">
            <el-tooltip class="item" effect="dark" content="Temporary inventory" placement="top">
              <el-button size="small">
                <i class="el-icon-document"></i>
              </el-button>
            </el-tooltip>
          </router-link>
        </el-badge>
      </span>
    </div>
    <div class="demo-input-suffix">
      Selected
      <span id="num">0</span>
      <el-select v-model="Batchoperationvalue" placeholder="Please choose" style="width:150px">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button
        style="background:#8989ba;color:#fff;outline: none"
        @click="Batchoperation"
      >Batch Operation</el-button>
      <span class="Synchronize" style="cursor: pointer;" @click="Synchronize">
        Synchronize Shopify product information
        <i
          v-bind:class="[isActive ? 'el-icon-refresh' : 'el-icon-loading']"
        ></i>
      </span>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @filter-change="handleFilterChange"
      v-loading="loading"
    >
      <el-table-column type="selection" :selectable="selectable" width="60" fixed="left"></el-table-column>
      <el-table-column prop="image" label="Image" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.image" min-width="70" height="70">
        </template>
      </el-table-column>
      <el-table-column prop="sku" label="SKU" show-overflow-tooltip></el-table-column>
      <el-table-column prop="desc_en" label="Product name"></el-table-column>
      <el-table-column prop="weight" label="Weight(KG)"></el-table-column>
      <el-table-column prop="worth" sortable label="Value(USD)" width="130"></el-table-column>
      <el-table-column
        prop="status"
        :filters="status"
        :filter-multiple="false"
        column-key="status"
        filter-placement="right-start"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>
            status
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                Description of product status
                <br>1.Synchronized-to-be-perfected information: Sku basic information is synchronized, but it needs to be perfected before it can be stored.
                <br>2.Warehousing: Products that have been put into storage and put on shelf, information can not be modified
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="inventory"
        label="numb"
        :filters="tab"
        :filter-multiple="false"
        column-key="inventory"
        filter-placement="right-start"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="Operation" width="300" fixed="right">
        <template slot-scope="scope">
          <a @click="perfect(scope)" v-if="scope.row.status=='Unsynchronization'">edit</a>
          <a
            @click="Warehousing(scope)"
            v-if="scope.row.status=='Synchronization'|| scope.row.status=='Warehoused'"
          >Warehousing</a>
          <a
            @click="details(scope)"
            v-if="scope.row.status=='Synchronization'||scope.row.status=='Warehoused'"
          >Details</a>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 1000]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <div id="details">
      <deta-ils :visible="addVisible" :companydata="companyList" @clearAdd="clearAdd"></deta-ils>
      <Edit-ing :visible="editVisible" :companydata="companyList" @clearEdit="clearEdit"></Edit-ing>
    </div>
  </div>
</template>
<script>
import { getproduct, downproduct } from '../api/product'
import { gettokenuser } from '../api/user'
import { setItem, getItem } from '../../utils/locstorage'
import { getToken, setToken } from '../../utils/auth'

import store from '@/store'

import details from './details/details'
import Editing from './Editing/Editing'
export default {
  components: {
    'deta-ils': details,
    'Edit-ing': Editing
  },
  data () {
    return {
      userStatus: '', // 用户认证状态
      storage: '0',
      companyList: '',
      addVisible: false,
      editVisible: false,
      isActive: true,
      Queryproductval: '',
      stockType: '',
      loading: true,
      statusType: '',
      keyword: '',
      total: 0,
      currentPage: 1,
      pageSize: 10,
      statetip:
        'Description of product status\nSynchronized-to-be-perfected information: Sku basic information is synchronized, but it needs to be perfected before it can be stored.',
      tableData: [

      ],
      multipleSelection: [],
      tab: [{ text: 'In stock', value: 2 }, { text: 'Shortage', value: 1 }],
      status: [
        { text: 'Unsynchronization', value: 1 },
        { text: 'Synchronization', value: 2 },
        { text: 'Warehoused', value: 3 }
      ],
      options: [
        {
          value: '2',
          label: 'Join the provisional list'
        },
        {
          value: '4',
          label: 'Warehousing'
        }
      ],
      Batchoperationvalue: ''
    }
  },
  computed: {
    //   getStatus(){
    //       return store.getters.status
    //   }
  },
  created: function () {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    // this.fetchData();
    this.userStatus = store.getters.status
  },
  mounted () {
    // this.loading = false
    // this.editVisible = true
    let user = store.getters.shopTokenuser.customer_id
    let getItemsize = getItem(user)
    getItemsize = JSON.parse(getItemsize)
    if (getItemsize != undefined) {
      this.storage = getItemsize.length
    }
    let param = {
      page: 1,
      pageSize: 10
    }
    getproduct(param)
      .then(response => {
        console.log(response)
        this.loading = false
        if (response.data.ask == 1) {
          this.tableData = response.data.data
          this.total = Number(response.data.count)
        }
      })
      .catch(error => {
        console.log(error)
      })

    // this.$refs.multipleTable.toggleRowSelection(this.tableData[0],true);//默认选中
  },

  methods: {
    handleFilterChange (val) {
      console.log(val)
      if (Object.keys(val)[0] == 'inventory') {
        if (val.inventory.length > 0) {
          this.stockType = val.inventory[0]

          let param = {
            page: 1,
            pageSize: 10,
            stockType: val.inventory[0]
          }
          console.log(param)
          this.getlist(param)
        } else {
          this.stockType = 0

          let param = {
            page: 1,
            pageSize: 10,
            stockType: 0
          }
          console.log(param)
          this.getlist(param)
        }
      } else if (Object.keys(val)[0] == 'status') {
        if (val.status.length > 0) {
          this.statusType = val.status[0]
          let param = {
            page: 1,
            pageSize: 10,
            statusType: val.status[0]
          }
          console.log(param)
          this.getlist(param)
        } else {
          this.statusType = 0
          let param = {
            page: 1,
            pageSize: 10,
            statusType: 0
          }
          console.log(param)
          this.getlist(param)
        }
      }
    },

    getRowKeys (row) {
      return row.id
    },

    getlist (param) {
      this.loading = true
      getproduct(param)
        .then(response => {
          this.loading = false
          // console.log(response);
          if (response.data.ask == 1) {
            // this.loading=false
            console.log(response)
            this.tableData = response.data.data
            this.total = Number(response.data.count)
          }
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    selectable (row, index) {
      // console.log(row)
      if (row.productid != null && row.status != 'Unsynchronization') {
        return true
      } else {
        return false
      }
    },
    handleSelectionChange (val) {
      console.log(val)
      this.multipleSelection = val
      document.getElementById('num').innerHTML = val.length
    },
    callbackFunction (result) {},

    handleSizeChange (val) {
      console.log(val)
      this.pageSize = val
      this.currentPage = 1
      let param = {
        page: this.currentPage,
        pageSize: this.pageSize,
        stockType: this.stockType,
        statusType: this.statusType
      }
      this.getproductlist(param)

      // this.fetchData(1, val);
      // console.log(`每页 ${val} 条`);
    },

    getproductlist (param) {
      this.loading = true
      getproduct(param)
        .then(response => {
          this.loading = false
          if (response.data.ask == 1) {
            this.tableData = response.data.data
            this.total = Number(response.data.count)
          }
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      console.log(val)
      let param = {
        page: val,
        pageSize: this.pageSize,
        stockType: this.stockType,
        statusType: this.statusType
      }
      this.getproductlist(param)

      // this.fetchData(val, this.pageSize);
      // console.log(`当前页: ${val}`);
    },
    // 批量操作
    Batchoperation () {
      if (this.Batchoperationvalue == '') {
        this.$message.error('Please choose the mode of operation.')
      } else if (this.multipleSelection.length == 0) {
        this.$message.error('Please select the operation object')
      } else {
        if (this.Batchoperationvalue == 2) {
          console.log(this.multipleSelection)
          let user = store.getters.shopTokenuser.customer_id
          let getItemsize = getItem(user)
          console.log(getItemsize)
          getItemsize = JSON.parse(getItemsize)
          console.log(getItemsize)
          if (getItemsize != null && getItemsize != 'undefined') {
            // let zcgetItemsize=[]
            for (let i = 0; i < this.multipleSelection.length; i++) {
              // for (let j = 0; j < getItemsize.length; j++) {
              // console.log(getItemsize[j]+">>>>"+this.multipleSelection[i].productid)
              // console.log(j+">>>>"+i)
              // if (getItemsize[j] == this.multipleSelection[i].productid) {
              getItemsize.push(this.multipleSelection[i].productid)
              //
              console.log(getItemsize)

              let temp = [] // 一个新的临时数组
              for (let i = 0; i < getItemsize.length; i++) {
                if (getItemsize[i] != null) {
                  if (temp.indexOf(getItemsize[i]) == -1) {
                    temp.push(getItemsize[i])
                  }
                }
              }
              console.log(temp)

              this.storage = temp.length

              setItem(user, JSON.stringify(temp))
              // }
              // }
            }
            // console.log(zcgetItemsize)
            //
          } else {
            let getItemsize = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              getItemsize.push(this.multipleSelection[i].productid)
              setItem(user, JSON.stringify(getItemsize))
              this.storage = getItemsize.length
            }
          }
        } else if (this.Batchoperationvalue == 4) {
          if (store.getters.status !== 'Certified') {
            this.$confirm(
              'The warehousing operation is required only after passing the certification.',
              'Your account has not been certified !',
              {
                confirmButtonText: 'Authenticate now',

                type: 'warning'
              }
            )
              .then(() => {
                console.log(store.getters.shopTokenuser.customer_id)
                let param = {
                  customer_id: store.getters.shopTokenuser.customer_id,
                  secretkey: '3d878b3aeae9d5d389a7c82a27708c6a'
                  //
                }
                gettokenuser(param)
                  .then(response => {
                    this.loading = false
                    if (response.data.ask == 1) {
                      document.cookie =
                        'token=' +
                        response.data.token +
                        ';path=/;domain=.sendfromchina.com'
                      window.open('http://ffment.sendfromchina.com/activation/activation')
                    }
                  })
                  .catch(error => {
                    this.loading = false
                    console.log(error)
                  })

                //
              })
              .catch(() => {})

            return
          }
          let getItemsize = []
          console.log(444)
          for (let i = 0; i < this.multipleSelection.length; i++) {
            getItemsize.push(this.multipleSelection[i].productid)
            setItem('Warehousing', JSON.stringify(getItemsize))
          }
          this.$router.push({ path: '/newans' })
        }
      }
    },
    // 查询商品
    Queryproduct () {
      this.loading = true
      let param = {
        page: 1,
        pageSize: 10,
        sku_or_name: this.Queryproductval
      }
      getproduct(param)
        .then(response => {
          this.loading = false
          console.log(response)
          // if (response.data.ask == 1) {
          this.tableData = response.data.data
          this.total = Number(response.data.count)
          // }
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    // 批量同步shopify产品信息
    Synchronize () {
      this.isActive = false

      downproduct()
        .then(response => {
          console.log(response)

          if (response.data.ask == 1) {
            this.isActive = true
            let param = {
              page: 1,
              pageSize: 10
            }
            getproduct(param)
              .then(response => {
                console.log(response)
                this.loading = false
                if (response.data.ask == 1) {
                  this.tableData = response.data.data
                  this.total = Number(response.data.count)
                }
              })
              .catch(error => {
                console.log(error)
              })
            this.$message({
              type: 'warning',
              message: response.data.msg
            })
          } else {
            this.isActive = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // ////同步单条shopify产品信息
    // cff(scope) {
    //   console.log(scope);
    // },
    // 取消同步
    // Cancelcff(scope) {
    //   console.log(scope);
    // },
    // 完善信息
    perfect (scope) {
      console.log(scope.row.productid)
      let param = {
        sku: scope.row.sku
      }
      getproduct(param)
        .then(response => {
          console.log(response)
          if (response.data.ask == 1) {
            console.log(response.data.data)
            this.companyList = response.data.data[0]
            this.editVisible = true
            console.log(this.companyList.desc_cn)
            // this.total = Number(response.data.count);
          }
        })
        .catch(error => {
          console.log(error)
        })

      // console.log(scope);
    },
    // 入库
    Warehousing (scope) {
      console.log(store.getters)
      console.log(this.userStatus)
      if (store.getters.status !== 'Certified') {
        this.$confirm(
          'The warehousing operation is required only after passing the certification.',
          'Your account has not been certified !',
          {
            confirmButtonText: 'Authenticate now',

            type: 'warning'
          }
        )
          .then(() => {
            let param = {
              customer_id: store.getters.shopTokenuser.customer_id,
              secretkey: '3d878b3aeae9d5d389a7c82a27708c6a'
              //
            }
            gettokenuser(param)
              .then(response => {
                this.loading = false
                if (response.data.ask == 1) {
                  document.cookie =
                    'token=' +
                    response.data.token +
                    ';path=/;domain=.sendfromchina.com'
                  window.open('http://ffment.sendfromchina.com/activation/activation')
                }
              })
              .catch(error => {
                this.loading = false
                console.log(error)
              })

            //
          })
          .catch(() => {})

        return
      }
      console.log(scope)
      let getItemsize = []
      console.log(444)

      getItemsize.push(scope.row.productid)
      setItem('Warehousing', JSON.stringify(getItemsize))

      this.$router.push({ path: '/newans' })
    },
    // 详情
    details (scope) {
      console.log(scope.row.productid)
      let productid = []
      productid.push(scope.row.productid)
      let param = {
        productid
      }
      getproduct(param)
        .then(response => {
          console.log(response)
          if (response.data.ask == 1) {
            console.log(response.data.data)
            this.companyList = response.data.data[0]
            this.addVisible = true
            console.log(this.companyList.desc_cn)
            // this.total = Number(response.data.count);
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 修改信息
    clearAdd () {
      this.addVisible = false
    },
    clearEdit () {
      this.editVisible = false
    }
  }
}
</script>
<style>
.Synchronize {
  float: right;
  font-size: 14px;
  color: #8989ba;
}
.ban {
  background: #fff;
  margin: 20px;
  padding: 20px;
}
.demo-input-suffix {
  padding-bottom: 20px;
  text-align: left;
}
.input {
  width: 200px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
a {
  color: #8989ba;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/views/MyProducp/MyProducp.vue